import type { AddDiscountCodeStatus, CartsState } from '../CartsState';
import { type Draft, PayloadAction } from '@reduxjs/toolkit';
import removeFirstMatchingItemFromArray from '../../removeFirstMatchingItemFromArray';

export interface AddEmployeeDiscountCodeToCurrentCartsRequestedPayload {
  readonly requestedActionId: number;
}

export const addEmployeeDiscountCodeToCurrentCartsRequestedReducer = (
  state: Draft<CartsState>,
  {
    payload: { requestedActionId }
  }: PayloadAction<AddEmployeeDiscountCodeToCurrentCartsRequestedPayload>
): void => {
  state.pageActions.addEmployeeDiscountCodeToCurrentCarts.pending.push(requestedActionId);
};

export interface AddEmployeeDiscountCodeToCurrentCartsSucceededPayload {
  readonly requestedActionId: number;
  readonly redemptionStatus: AddDiscountCodeStatus;
}

export const addEmployeeDiscountCodeToCurrentCartsSucceededReducer = (
  state: Draft<CartsState>,
  {
    payload: { requestedActionId, redemptionStatus }
  }: PayloadAction<AddEmployeeDiscountCodeToCurrentCartsSucceededPayload>
): void => {
  const { pending, succeeded } = state.pageActions.addEmployeeDiscountCodeToCurrentCarts;

  succeeded.push({ requestedActionId, redemptionStatus });
  removeFirstMatchingItemFromArray(pending, requestedActionId);
};

export interface AddEmployeeDiscountCodeToCurrentCartsFailedPayload {
  readonly requestedActionId: number;
  readonly redemptionStatus: AddDiscountCodeStatus;
}

export const addEmployeeDiscountCodeToCurrentCartsFailedReducer = (
  { pageActions: { addEmployeeDiscountCodeToCurrentCarts } }: Draft<CartsState>,
  {
    payload: { requestedActionId, redemptionStatus }
  }: PayloadAction<AddEmployeeDiscountCodeToCurrentCartsFailedPayload>
): void => {
  const { pending, failed } = addEmployeeDiscountCodeToCurrentCarts;
  failed.push({
    requestedActionId,
    redemptionStatus
  });
  removeFirstMatchingItemFromArray(pending, requestedActionId);
};
